export enum ErrorMessageEnum {
  TECHNICAL_ERROR = 'Technical error, please contact us or try again!'
}
